const BASE_URL : string = 'https://www.makemytrip.com';
export const TY_CROSS_SELL_URL : string = `${BASE_URL}/cabs-cb/api/cross-sell/rails/widget`;